<template>
  <div v-if="isLoading" class="load">
    <div class="splash-screen">
      <img class="Loading" src="@/assets/logo.png" alt="mizabook bookstore" />
      <div class="progress-container">
        <div class="progress-bar" :style="{ width: progress + '%' }"></div>
        <span class="progress-text">{{ progress }}%</span>
      </div>
    </div>
  </div>
  <div v-else>
    <app-layout>
      <router-view />
    </app-layout>
  </div>
</template>
<script>
import AppLayout from "@/components/global/AppLayout.vue";

export default {
  data() {
    return {
      isLoading: true,
      progress: 0,
    };
  },
  components: {
    AppLayout,
  },
  mounted() {
    this.startLoading();
  },
  methods: {
    startLoading() {
      // Simulate loading progress
      const loadingInterval = setInterval(() => {
        if (this.progress < 100) {
          this.progress += 1; // Increase the progress
        } else {
          clearInterval(loadingInterval); // Stop when progress reaches 100%
          this.isLoading = false; // Hide the loading screen
        }
      }, 30); // Adjust this value to speed up or slow down the loading
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.load {
  height: 100vh; /* bach t7dd l-height b 100% mn l-screen height */
  background-image: url(/src/assets/helloa.png);
  background-size: cover;
  margin-top: 0; /* 7ayid margin lfo9 */
  background-position: center; /* dayer background mn nss screen */
}

.Loading {
  width: 100%; /* t7dd l-width b % mn width l-screen */
}

.splash-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 150px; /* size mo3aqal l-splash screen */
  height: 150px;
  animation: zoomInOut 1.5s ease-in-out infinite;
}

.progress-bar {
  height: 100%;
  background-color: #4caf50;
  width: 0;
  transition: width 0.3s ease;
}

.progress-text {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  color: #000;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
}

@media (max-width: 768px) {
  .Loading {
    width: 100%; /* bach ybqa mnasib f l-screens sghir */
  }

  .splash-screen {
    width: 120px;
    height: 120px;
  }

  .progress-text {
    font-size: 12px; /* sghir l-font f screens l-sghira */
  }
}

@media (max-width: 480px) {
  .Loading {
    width: 100%; /* tkhdm mzyan l-phones */
  }

  .splash-screen {
    width: 100px;
    height: 100px;
  }

  .progress-text {
    font-size: 10px; /* adjust font size f smartphones */
  }
}

/* Animation for zoom in and out */
@keyframes zoomInOut {
  0% {
    transform: translate(-50%, -50%) scale(1); /* Normal size */
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1); /* Zoom in */
  }
  100% {
    transform: translate(-50%, -50%) scale(1); /* Back to normal */
  }
}
</style>
